/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormularyType } from '@absg/nim-client-shared';

export class CheckPracticeOwnedStatusPillHelper {
  static isPracticeOwnedProductDetailItem(item: any): boolean {
    let retVal = false;
    if (item && item.productDetail) {
      retVal = (item.productDetail.formularyTypeId === FormularyType.PracticeOwnedItem);
    }
    return retVal;
  }

  static isDisContinuedProductDetailItem(item: any): boolean {
    let retVal = false;
    if (item && item.productDetail) {
      retVal = item.productDetail.isDiscontinued;
    }
    return retVal;
  }

  static isPracticeOwnedItem(item: any): boolean {
    let retVal = false;
    if (item) {
      retVal = (item.formularyTypeId === FormularyType.PracticeOwnedItem);
    }
    return retVal;
  }
  static isMasterOwnedForSelectedItem(item: any): boolean {
    return (item && item.productDetail) ?
      item.productDetail.formularyTypeId === FormularyType.MasterOwnedItem : false;
  }

  static isPracticeOwnedForSelectedItem(item: any): boolean {
    return (item && item.productDetail) ?
      item.productDetail.formularyTypeId === FormularyType.PracticeOwnedItem : false;
  }
}
